import React, { useEffect, useRef, useState } from "react";
import CardSection from "../../../components/ui/card/CardSection";
import { AppIcons } from "../../../data/appIcons";
import SkillCategoryList from "../../../features/skills/skillCategoryList/SkillCategoryList";
import "./SkillCategory.scss"
import SidebarModel from "../../../components/ui/sidebarModel/SidebarModel";
import AddSkillCategory from "../../../features/skills/skillCategoryList/AddSkillCategory";
import SkillCategoryDataFields from "../../../features/skills/skillCategoryList/SkillCategoryList.Data";
import { onResetForm } from "../../../utils/FormFields/ResetForm/handleResetForm";
import useDebounce from "../../../app/customHooks/useDebounce";
import { hasFunctionalPermission } from "../../../utils/authorizeNavigation/authorizeNavigation";
import { securityKey } from "../../../data/SecurityKey";

const SkillCategory = () => {

   const [isModelOpen, setModelOpen] = useState(false);
   const molGridList = useRef();
   const [formData, setFormData] = useState(SkillCategoryDataFields.initialState);
   const [isEdit, setIsEdit] = useState(false);
   const [search, setSearch] = useState("");
   const debouncedSearch = useDebounce(search, 300);
   const [hasAddBtnPermission, setHasAddBtnPermission] = useState(false);
   const hasAddPermission = hasFunctionalPermission(securityKey.ADDSKILL);


   useEffect(() => {
    if (hasAddPermission?.hasAccess) {
      setHasAddBtnPermission(true);
    } else {
      setHasAddBtnPermission(false);
    }
  }, [hasAddPermission]);

    //**Handle Change */
  const handleChange = (event) => {
    const value = event.target.value;
    setSearch(value.trim());
  };

  const handleAdd = () => {
    setIsEdit(false);
    resetForm();
    setModelOpen(true);
  };

  const handleEdit = (data) => {
      resetForm();
      setFormData(data);
      setIsEdit(true);
      setModelOpen(true);
  };

  //** Reset Data */
  const resetForm = () => {
      let form = { ...SkillCategoryDataFields };
      onResetForm(form, setFormData, null);
  };

  //** Close model */
  const onSidebarClose = () => {
          setModelOpen(false);
      resetForm();
  };

  //** Success */
  const onSuccess = () => {
      if (molGridList.current && molGridList.current.refreshGrid) {
          molGridList.current.refreshGrid();
      }
  };

  return (
    <div className="margin-b-0">
      <CardSection
        cardTitle="Skill Category"
        buttonText="Add"
        buttonClassName="btn theme-btn"
        searchInput={true}
        searchInputName="Search By Skill Category"
        handleChange={handleChange}
        titleButtonClick={handleAdd}
        rightButton={true}
        hasButtonPermission={hasAddBtnPermission}
        textWithIcon={false}
        iconImg={AppIcons.addIcon}
      >
        <div className="skillCategory-table">
            <SkillCategoryList  
              onEdit={handleEdit}
              search={debouncedSearch}
              ref={molGridList} 
            />
        </div>
      </CardSection>
      <SidebarModel
        modalTitle={`${isEdit ? "Update" : "Add"} Skill Category`}
        modalSize="w-35"
        onClose={onSidebarClose}
        isOpen={isModelOpen}
      >
        <div className="sub-skill-detail">
          <AddSkillCategory 
            onClose={onSidebarClose}
            isEdit={isEdit}
            initData={formData}
            onSuccess={onSuccess}
            onReset={resetForm}
            isModelOpen={isModelOpen}
          />
        </div>
      </SidebarModel>
    </div>
  );
};

export default SkillCategory;
